import React from 'react'
import type { FreshnessState } from '@/types/status'

interface StaleBadgeProps {
  freshness: FreshnessState
  label?: string
}

const config: Record<FreshnessState, { color: string; defaultLabel: string } | null> = {
  fresh: null,
  stale: {
    color: 'text-warning border-warning/30 bg-warning/5',
    defaultLabel: 'Stale',
  },
  critical: {
    color: 'text-error border-error/30 bg-error/5',
    defaultLabel: 'Critical — data may be very old',
  },
}

export function StaleBadge({ freshness, label }: StaleBadgeProps) {
  const cfg = config[freshness]
  if (!cfg) return null

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded border text-tiny font-semibold ${cfg.color}`}
    >
      {label ?? cfg.defaultLabel}
    </span>
  )
}
